import React, { Component } from 'react';
import { connect } from 'react-redux';
import Header from '../../../common_components/Header';
import AdminHeader from '../../../common_components/admin_module_header';
// import Drawer from '../../common_components/Drawer';
import { lastSubmitAdd_action } from '../../../actions/last_submit_action'
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { withRouter } from '../../../utils/withRouter';
import moment from 'moment';
import Modal from "react-modal";
import Loader from '../../../utils/Loader'
import { getPaymentOrderDetails_action, insertHotelEnquiryDownload_action } from '../../../actions/registration_action'
import { clearSessionStorage, countryActionId, toastError, toastSuccess, countryIWithCodeActionId, DOC_BASE_URL, link_BASE_URL } from '../../../utils/constants'
import Pagination from '../../../utils/pagination'
import { useEffect, useState } from 'react';
import { useNavigate, Link } from "react-router-dom";
import { fill_action } from '../../../actions/fillCombo_action'
// import StepHeader from './stepHeader'
import Footer from '../../../common_components/Footer';
// import {
//  approveWaiveOff_action
// } from "../../../actions/exhibitor_module_actions/exhibitor_exit_pass_action/exhibitor_exit_pass_action";
import { approveWaiveOff_action, checkIfApproved_action } from "../../../actions/admin_module_action/account_exit_pass_action/account_exit_pass_action";

class ExitPassWaiveOff extends Component {
    constructor(props) {
        super(props)
        this.state = {
            isLoading: false,
            scripts: [],


            exitPassId: '',
            userId: '',
            exitPassNo: '',
            exhRegno: '',
            approvalStatus: false,
            approvedByName: '',
            //   isWaiverOn: true
        }

        this.approveWaiveOff = this.approveWaiveOff.bind(this)
        this.checkWaiveOff = this.checkWaiveOff.bind(this)
        this.onPreviousClick = this.onPreviousClick.bind(this)
        // this.getPaymentDetails = this.getPaymentDetails.bind(this)
        // this.downloadFileHotelEnquiry = this.downloadFileHotelEnquiry.bind(this)
    }



    componentWillUnmount() {
        const { isClickValidation, scripts, isNavForm } = this.state
        if (!isNavForm) {
            sessionStorage.clear()
            // if (!isClickValidation) {
            //     window.location.replace('http://localhost:3000/#/');
            // }

            if (scripts) {
                scripts.forEach((script) => {
                    if (script.parentNode) {
                        script.parentNode.removeChild(script);
                    }
                });
            }
        }
    }



    componentDidMount() {
        console.log('session : ', sessionStorage);
        // window.history.pushState(null, "", window.location.href);
        // window.onpopstate = function () {
        //     window.history.pushState(null, "", window.location.href);
        // };
        // if (sessionStorage.getItem('sessionExhibitionID') != null) {

        //     this.callGAScripts()
        //     var exhno = this.props.location.state != null && this.props.location.state != "" && this.props.location.state.ExhRegistrationNo != " " ? this.props.location.state.ExhRegistrationNo : ''
        //     // Exhibition From Date
        //     const dateString = sessionStorage.getItem('exhibitionDateFrom');
        //     const isFromDateValid = moment(dateString, "DD/MM/YYYY", true).isValid()
        //     const dateStringMoment = isFromDateValid ? moment.utc(dateString, "DD/MM/YYYY").format('DD MMMM YYYY') : moment.utc(dateString).format('DD MMMM YYYY')
        //     const dateObject = new Date(dateStringMoment);
        //     const fromDay = dateObject.getDate();
        //     const fromMonth = dateObject.toLocaleString('default', { month: 'long' });
        //     const fromYear = dateObject.getFullYear();
        //     const ExfromDate = `${fromDay} ${fromMonth} ${fromYear}`;
        //     console.log('dateString', dateString)
        //     console.log('dateStringMoment', dateStringMoment)
        //     console.log('dateObject', dateObject)

        //     // Exhibition to Date
        //     const dateString1 = sessionStorage.getItem('exhibitionDateTo');
        //     const isToDateValid = moment(dateString1, "DD/MM/YYYY", true).isValid()
        //     const dateString1Moment = isToDateValid ? moment.utc(dateString1, "DD/MM/YYYY").format('DD MMMM YYYY') : moment.utc(dateString1).format('DD MMMM YYYY')
        //     const dateObject1 = new Date(dateString1Moment);
        //     const toDay = dateObject1.getDate();
        //     const toMonth = dateObject1.toLocaleString('default', { month: 'long' });
        //     const toYear = dateObject1.getFullYear();
        //     const ExtoDate = `${toDay} ${toMonth} ${toYear}`;
        //     this.setState({
        //         geturl: this.props.location.state != null && this.props.location.state != "" && this.props.location.state.geturl != " " ? this.props.location.state.geturl : '',
        //         is_partner: this.props.location.state != null && this.props.location.state != "" && this.props.location.state.is_partner != " " ? this.props.location.state.is_partner : '',
        //         exhibitionAdd: this.props.location.state != null && this.props.location.state != "" && this.props.location.state.exhibitionAdd != " " ? this.props.location.state.exhibitionAdd : '',
        //         exhibitionName: this.props.location.state != null && this.props.location.state != "" && this.props.location.state.exhibitionName != " " ? this.props.location.state.exhibitionName : '',
        //         ExhRegistrationNo: exhno,
        //         fromDate: this.props.location.state != null && this.props.location.state != "" && this.props.location.state.fromDate != " " ? this.props.location.state.fromDate : (sessionStorage.getItem('exhibitionDateFrom') != null && sessionStorage.getItem('exhibitionDateFrom') != '') ? ExfromDate : '',
        //         toDate: this.props.location.state != null && this.props.location.state != "" && this.props.location.state.toDate != " " ? this.props.location.state.toDate : (sessionStorage.getItem('exhibitionDateTo') != null && sessionStorage.getItem('exhibitionDateTo') != '') ? ExtoDate : '',
        //         SSRLink: sessionStorage.getItem('SSRLink')
        //     }, () => {
        //         sessionStorage.setItem('is_partner', this.props.location.state != null && this.props.location.state != "" && this.props.location.state.is_partner != " " ? this.props.location.state.is_partner : null)
        //     })
        //     this.getPaymentDetails()
        // }
        var fullUrl = window.location.href;
        fullUrl = fullUrl.split("/");
        if (fullUrl[fullUrl.length - 1].includes('&&')) {
            var fullUrlSplit = fullUrl[fullUrl.length - 1].split('&&')
            console.log(fullUrlSplit);
            // var exno=
            var tempExNo = JSON.parse(JSON.stringify(fullUrlSplit[1]))
            if (tempExNo.includes('-')) {
                tempExNo = tempExNo.replace("-", "/")
            }
            if (tempExNo.includes('-')) {
                tempExNo = tempExNo.replace("-", "/")
            }
            this.setState({
                exitPassId: fullUrlSplit[0],
                // userId: 232,
                userId: fullUrlSplit[2],
                exitPassNo: tempExNo,
                // exhRegno: ''
            }, () => {
                this.checkWaiveOff(fullUrlSplit[0]).then(res => {
                    if (res == 1) {
                        this.approveWaiveOff(fullUrlSplit[2], fullUrlSplit[0])
                    }
                })
            })
        }
    }

    async callGAScripts() {
        const { scripts } = this.state
        const script1 = document.createElement("script");
        script1.async = true;
        script1.src = "https://www.googletagmanager.com/gtag/js?id=G-1QY8MXN64V";
        document.head.appendChild(script1);
        scripts.push(script1); // Store reference

        const script2 = document.createElement("script");
        script2.innerHTML = `
      window.dataLayer = window.dataLayer || [];
      function gtag(){dataLayer.push(arguments);}
      gtag('js', new Date());
      gtag('config', 'G-1QY8MXN64V');
    `;
        document.head.appendChild(script2);
        scripts.push(script2)
    }

    onPreviousClick(e) {
        const { isClickValidation } = this.state
        e.preventDefault();
        var url = sessionStorage.getItem('sessionExhMailWebsite')
        this.setState({ isClickValidation: true }, () => {
            sessionStorage.clear()
            const win = window.location.replace(url)
            // const win = window.open(this.state.geturl, '_blank');
            if (win != null) {
                win.focus();
            }
        })
    }

    checkWaiveOff(exid) {
        return new Promise(async (resolve, reject) => {
            this.props
                .checkIfApproved_action(exid)
                .then((data) => {
                    if (data.error != 1) {
                        console.log(data)
                        if (data.data[0][0].WaiveOffStatus != "0") {
                            console.log('here')
                            this.setState({
                                approvalStatus: true, approvedByName: data.data[0][0].WaiveOffStatus
                            })
                            resolve(0)
                        } else {
                            resolve(1)
                        }
                    } else {
                        this.setState({ isLoading: false });
                        // toastError(data.msg);
                    }
                })
                .catch((err) => {
                    console.log(err);
                })
        })
    }


    approveWaiveOff(userid, exid) {
        // console.log(id);
        this.setState({ isLoading: true });
        this.props
            .approveWaiveOff_action(userid, exid)
            .then((data) => {
                if (data.error != 1) {
                    this.setState({ isLoading: false });
                    this.setState({ exhRegno: data.data[1][0].ExhRegistrationNo })
                    // console.log("Proforma Pdf Download", data);
                    //   var url = `${downloadReport}?SessionIdentifier=${data}&Export=true`;
                    //   const win = window.location.replace(url, "_blank");
                    //   if (win != null) {
                    //     win.focus();
                    //   }
                } else {
                    this.setState({ isLoading: false });
                    toastError(data.msg);
                }
            })
            .catch((err) => {
                console.log(err);
            });
    }

    backToLogin(e) {
        const { isClickValidation } = this.state
        e.preventDefault();
        // var url = sessionStorage.getItem('sessionExhMailWebsite')
        this.setState({ isClickValidation: true }, () => {
            const win = window.location.replace(`${link_BASE_URL}`)
            setTimeout(() => {
                sessionStorage.clear()
                // const win = window.open(this.state.geturl, '_blank');
                if (win != null) {
                    win.focus();
                }
            }, 500);
        })
    }

    render() {
        const { isLoading, geturl, approvalStatus, approvedByName, exitPassNo, SSRLink, is_partner, exhRegno, exhibitionAdd, fromDate, toDate, exhibitionName, ExhRegistrationNo } = this.state
        console.log(sessionStorage.getItem('SSRLink'))
        return (
            <>
                {isLoading ? (
                    <Loader></Loader>
                ) : (null)}
                <ToastContainer />
                {/* <!-- PAGE --> */}
                {/* <Header /> */}
                {!sessionStorage.getItem('sessionExhibitionID') ? (<AdminHeader isSteper={false} />) : (<Header />)}
                {/* <!-- CONTAINER --> */}
                <div >
                    {/* <StepHeader /> */}

                    {/* <!-- ROW-1 --> {geturl}*/}
                    <div
                        className="main-content app-content mt-0"
                        style={{ backgroundColor: "#ececec", height: '100vh' }}
                    >
                        <div className="side-app">
                            <div className="main-container container-fluid top-form-name">
                                <div className="row ">
                                    <form className="needs-validation " noValidate="">
                                        <div className="form-row mt-4">
                                            {approvalStatus ? <div className="form-group col-md-7 p-4 thank-box">
                                                <div className="form-group mb-2">
                                                    <h4
                                                        className="mb-0 pt-2 pb-4 thank-top-mes"
                                                        style={{ color: "#318958" }}
                                                    >
                                                        <strong>Waive off already Approved</strong>
                                                    </h4>
                                                    <p className="mb-1 mt-1 text-center com-font">
                                                        Waive off has been already sucessfully approved by {approvedByName} for Material Exit pass No.
                                                    </p>
                                                    <h5 className="mb-4 pt-1" style={{ fontWeight: "bold" }}>
                                                        <strong>
                                                            <span>{exitPassNo} </span></strong>
                                                    </h5>
                                                    <p className="mb-0 mt-2 text-center com-font">
                                                        {/* Kindly check your registered email
                                                        address for acknowledgement of application. */}
                                                        {/* and 1st <br></br> Proforma
                                                        for space booking amount. */}
                                                    </p>
                                                </div>
                                                <div classname="" style={{ display: 'flex', justifyContent: 'center', alignItems: 'end' }}>

                                                </div>
                                            </div> : <div className="form-group col-md-7 p-4 thank-box">
                                                <div className="form-group mb-2">
                                                    <h4
                                                        className="mb-0 pt-2 pb-4 thank-top-mes"
                                                        style={{ color: "#318958" }}
                                                    >
                                                        <strong>Waive off Successfully Approved</strong>
                                                    </h4>
                                                    <p className="mb-1 mt-1 text-center com-font">
                                                        Waive off sucessfully approved for exhibitor Registration Number
                                                    </p>
                                                    <h5 className="mb-4 pt-1" style={{ fontWeight: "bold" }}>
                                                        <strong>
                                                            <span>{exhRegno} </span></strong>
                                                    </h5>
                                                    <p className="mb-0 mt-2 text-center com-font">
                                                        {/* Kindly check your registered email
                                                        address for acknowledgement of application. */}
                                                        {/* and 1st <br></br> Proforma
                                                        for space booking amount. */}
                                                    </p>
                                                </div>
                                                <div classname="" style={{ display: 'flex', justifyContent: 'center', alignItems: 'end' }}>

                                                </div>
                                            </div>}
                                        </div>
                                    </form>
                                </div>
                            </div>
                        </div>
                    </div>


                </div>
                <Footer />
                {/* <!-- CONTAINER END --> */}

            </>
        );
    }
}

export default withRouter(connect(null, {
    // lastSubmitAdd_action, getPaymentOrderDetails_action, insertHotelEnquiryDownload_action
    approveWaiveOff_action, checkIfApproved_action
})(ExitPassWaiveOff));

